<template>
  <div>
    <v-container fluid class="mx-12 my-6 main-container">
      <div class="card-label d-flex flex-row mb-4">
        <v-icon>mdi-link-variant</v-icon>
        <p class="mb-0 ml-4 subtitle-1 font-weight-bold">Links</p>
      </div>
      <div class="d-flex align-center flex-row mb-6">
        <v-text-field
          v-model="searchString"
          solo
          flat
          append-icon="mdi-magnify"
          label="Search Links"
          hide-details
          @click:append="searchAction"
          @keydown.enter="searchAction"
        >
        </v-text-field>
        <v-btn
          color="primary"
          class="ml-4 font-weight-bold"
          :disabled="!access.create"
          depressed
          @click="newForm"
        >
          <v-icon class="pr-1">mdi-plus</v-icon>
          New Link
        </v-btn>
      </div>
      <div v-if="!loading">
        <v-card
          v-if="$store.state.forms.forms.length > 0"
          v-show="access.read"
          elevation="0"
        >
          <v-list two-line dense>
            <template v-for="form in $store.state.forms.forms">
              <v-list-item :key="form._id" dense>
                <v-list-item-icon>
                  <v-icon>mdi-drag-vertical</v-icon>
                </v-list-item-icon>
                <v-list-item-content class="py-0">
                  <v-list-item-title
                    ><p class="body-2 font-weight-bold">
                      {{ form.formTitle }}
                    </p></v-list-item-title
                  >
                  <v-list-item-subtitle>
                    <a :href="form.formUrl" target="_blank" class="caption">
                      {{ form.formUrl }}
                    </a>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <div>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn small icon v-on="on" @click="updateForm(form)">
                          <v-icon small>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <p class="white--text">Edit</p>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn small icon v-on="on" @click="deleteForm(form)">
                          <v-icon small color="red">mdi-close</v-icon>
                        </v-btn>
                      </template>
                      <p class="white--text">Delete</p>
                    </v-tooltip>
                  </div>
                </v-list-item-action>
              </v-list-item>
            </template>
          </v-list>
        </v-card>
        <v-card
          v-else
          elevation="0"
          class="flex-grow-1 d-flex flex-column justify-center align-center"
          style="height: 50vh"
          @click="newForm"
        >
          <p class="headline">You don't have any links yet!</p>
          <v-icon x-large>mdi-plus-circle</v-icon>
          <p class="subtitle-1">Create your first link</p>
        </v-card>
      </div>
      <v-skeleton-loader
        v-else
        ref="skeleton"
        type="list-item-avatar-two-line"
        loading
        class="mx-auto"
      ></v-skeleton-loader>
    </v-container>
    <NewForm ref="newForm"></NewForm>
    <UpdateForm ref="updateForm"></UpdateForm>
  </div>
</template>

<script>
import NewForm from '../components/forms/NewForm.vue'
import UpdateForm from '../components/forms/UpdateForm.vue'

export default {
  components: {
    NewForm,
    UpdateForm
  },
  data() {
    return {
      loading: true,
      searchString: ''
    }
  },
  computed: {
    access() {
      return this.$root.$roleAccess('links').access
    }
  },
  async mounted() {
    await this.reload()
    this.loading = false
  },
  methods: {
    async reload() {
      await this.$store.dispatch('forms/fetchFormsAction')
    },
    newForm() {
      this.$refs.newForm.open()
    },
    searchAction() {},
    async deleteForm(item) {
      if (
        await this.$root.$confirm({
          title: 'Delete Link',
          message: `Are you sure you want to delete the link "${item.formTitle}"?`
        })
      ) {
        this.loading = true
        if (
          await this.$store.dispatch('forms/deleteFormAction', {
            formId: item.formId
          })
        ) {
          this.$root
            .$confirm({
              title: 'Delete Link',
              message: `The link has been deleted.`,
              reconfirmOnly: true,
              confirmText: 'OK'
            })
            .then(() => {
              this.loading = false
              this.reload()
            })
        }
      }
    },
    async updateForm(item) {
      this.$refs.updateForm.open(item)
    }
  }
}
</script>

<style scoped>
.main-container {
  min-height: 100vh;
}
.v-card {
  border-radius: 12px !important;
}
.v-input {
  border-radius: 10px;
}
.v-btn {
  border-radius: 20px;
}
table tbody tr td {
  border: none !important;
  border-bottom: none !important;
}
p {
  margin-bottom: 0;
}
</style>
